<template>
    <div>
        <label v-if="label">{{ label }}</label>
        <div class="day-picker-container"
             :style="{gridGap: gap, cursor: readonly ? 'auto' : 'pointer'}"
             :class="[readonly ? 'flex-layout' : 'grid-layout', isModal && 'grid-layout-modal']">
            <div class="day"
                 :class="{active: day.selected}"
                 @click="selectDay(index)"
                 :style="{height, width}"
                 v-for="(day, index) of weekDays"
                 :key="index">
                {{ day.day.slice(0, 3) }}
            </div>
        </div>
    </div>
</template>

<script>
    import * as _ from 'lodash';
    import { mapGetters } from 'vuex';
    import { DAYS } from '../../constants/days';

    export default {
        name: 'DayPicker',
        inject: ['$validator'],
        props: {
            fontSize: Number,
            height: {
                type: String,
                default: '20px'
            },
            width: {
                type: String
            },
            gap: {
                type: String
            },
            value: Array,
            readonly: {
                type: Boolean,
                default: false
            },
            label: String,
            name: String
        },
        $_veeValidate: {
            value() {
                return this.value && this.value.filter(day => day).length;
            },
            name() {
                return this.name;
            }
        },
        watch: {
            value: {
                handler(value) {
                    value
                        ? value.forEach((el, index) => { this.weekDays[index].selected = el || false })
                        : this.weekDays = DAYS.map((day) => {
                            return {
                                day,
                                selected: false
                            }
                        })
                },
                immediate: true
            }
        },
        data() {
            return {
                weekDays: DAYS.map((day) => {
                    return {
                        day,
                        selected: false
                    }
                })
            }
        },
        computed: {
            ...mapGetters(['currentModal']),

            isModal() {
                return !_.isNull(this.currentModal);
            }
        },
        methods: {
            selectDay(index) {
                if (!this.readonly) {
                    this.weekDays[index].selected = !this.weekDays[index].selected;
                    this.$emit('input', this.weekDays);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/colors";

    .day-picker-container {
        font-family: Asap;
        .day {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 13px;
            text-align: center;
            color: $DayGrey;
            background: $ComplementaryBackgroundLightGrey;
            margin-right: 12px;
            border-radius: 3px;
            @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                width: 14.28%;
            }
            @media screen and (max-width: 991px) {
                margin-right: 6px;
            }
            @media screen and (max-width: 450px) {
                margin-right: 7px;
                height: 35px !important;
                width: 35px;
                min-width: 35px;
                font-size: 11px;
            }
        }
        .active {
            background: $Violet;
            color: $ComplementaryBackgroundLightGrey;
        }
    }

    .grid-layout {
        display: grid;
        grid-template-columns: repeat(7, minmax(33px, 1fr));
        grid-gap: 7px 12px;
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            display: flex;
        }
        @media screen and (max-width: 1200px){
            grid-gap: 7px 9px;
        }
        @media screen and (max-width: 991px){
            grid-gap: 7px 12px;
        }
        @media screen and (max-width: 767px){
            grid-gap: 7px;
        }
        @media screen and (max-width: 576px){
            grid-gap: 7px 3px;
        }
        @media screen and (max-width: 450px){
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }

    .grid-layout-modal {
        @media screen and (max-width: 450px){
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: normal;
        }
    }

    .flex-layout {
        display: flex;
        flex-wrap: wrap;
        .day {
            margin-top: 4px;
            margin-bottom: 3px;
        }
    }

    label {
        margin-bottom: 0;
        font-size: 14px;
        font-family: Asap;
        color: $WhiteGrey !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/controls/DayPicker.vue